import { withStyles, WithStyles } from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';
import moment from 'moment';
import * as React from 'react';
import MyTable from '../../components/UI/MyTable/MyTable';
import { IAsset } from '../../models/states';

const styles = () =>
  createStyles({
    root: {},
    actionButtons: {
      marginRight: '1rem'
    }
  });
class AssetHistory extends React.Component<IAssetHistoryProps> {
  constructor(props: IAssetHistoryProps) {
    super(props);
    this.state = {};
  }
  public render() {
    const { asset } = this.props;
    const historyTableHeader = [
      {
        label: 'timestamp',
        dataKey: 'time_stamp',
        isFilter: false,
        isSort: true,
        tooltip: true,
        lowercase: false
      },
      {
        label: 'change',
        dataKey: 'change',
        isFilter: false,
        isSort: false,
        tooltip: true,
        lowercase: true
      },
      {
        label: 'Actor',
        dataKey: 'actor',
        isFilter: false,
        isSort: false,
        tooltip: true
      },
      {
        label: 'Additional Info',
        dataKey: 'info',
        isFilter: false,
        isSort: false,
        tooltip: true,
        lowercase: true
      }
    ];
    const rows = asset.stateHistory.map((history: any, index: number) => {
      return {
        ...history,
        dataKey: index,
        time_stamp: moment
          .unix(history.time_stamp)
          .format('YYYY-MM-DD HH:mm:ss'),
        info: Object.keys(history.info)
          .map(i => {
            return `${i}:${history.info[i]}`;
          })
          .join(', ')
      };
    });
    return (
      <MyTable
        tRows={rows}
        multiSelect={false}
        tHead={historyTableHeader}
        order={'desc'}
        orderBy={'time_stamp'}
      />
    );
  }
}
interface IAssetHistoryOwnProps extends WithStyles<typeof styles> {
  asset: IAsset;
}
type IAssetHistoryProps = IAssetHistoryOwnProps;
export default withStyles(styles)(AssetHistory);
